import { render, staticRenderFns } from "./EditAgendaItem.vue?vue&type=template&id=10751cfe&scoped=true&"
import script from "./EditAgendaItem.vue?vue&type=script&lang=js&"
export * from "./EditAgendaItem.vue?vue&type=script&lang=js&"
import style0 from "./EditAgendaItem.vue?vue&type=style&index=0&id=10751cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10751cfe",
  null
  
)

export default component.exports